import { Grid } from "@vividtheory/minerva-lab";
import React from "react";
import { CompanyAvatar } from "./CompanyAvatar";
import { UploadSingleImage } from "./UploadSingleImage";
import { UserAvatar } from "./UserAvatar";
export const UploadSingleImageWithAvatar = ({ avatar, onImageChange, onLoadImageError, uploadLabel, imageType, app, overwrite, }) => {
    return (React.createElement(Grid, { sx: { display: "flex" }, alignItems: "center", gap: 2, flexWrap: "wrap" },
        React.createElement(Grid, { item: true }, imageType === "company" ? (React.createElement(CompanyAvatar, { size: "lg", src: avatar === null || avatar === void 0 ? void 0 : avatar.src, alt: (avatar === null || avatar === void 0 ? void 0 : avatar.alt) || imageType, color: "surface", sx: {
                border: 1,
                borderColor: (theme) => theme.palette.outline,
            } })) : (React.createElement(UserAvatar, { size: "lg", src: avatar === null || avatar === void 0 ? void 0 : avatar.src, alt: avatar === null || avatar === void 0 ? void 0 : avatar.alt, color: "surface", sx: {
                border: 1,
                borderColor: (theme) => theme.palette.outline,
            } }))),
        React.createElement(Grid, { item: true },
            React.createElement(UploadSingleImage, { withButton: true, label: uploadLabel, callbacks: {
                    onSuccess: (file) => onImageChange === null || onImageChange === void 0 ? void 0 : onImageChange(file.url),
                    onError: (err) => {
                        onLoadImageError === null || onLoadImageError === void 0 ? void 0 : onLoadImageError(err);
                    },
                }, app: app, overwrite: overwrite }))));
};
//# sourceMappingURL=UploadSingleImageWithAvatar.js.map